import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, createContext, useContext, useCallback } from "react";
import { X, ExternalLink } from "lucide-react";
import { useUITranslation } from '../../../i18n/index.js';
const ImageLightboxContext = createContext(null);
export function useImageLightbox() {
    const ctx = useContext(ImageLightboxContext);
    if (!ctx) {
        // Return a fallback that opens in new tab if no provider
        return {
            openImage: (src) => window.open(src, "_blank"),
            closeImage: () => { },
        };
    }
    return ctx;
}
export function ImageLightboxProvider({ children }) {
    const [image, setImage] = useState(null);
    const openImage = useCallback((src, alt) => {
        setImage({ src, alt });
    }, []);
    const closeImage = useCallback(() => {
        setImage(null);
    }, []);
    const { t } = useUITranslation();
    return (_jsxs(ImageLightboxContext.Provider, { value: { openImage, closeImage }, children: [children, image && (_jsx("div", { className: "fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm", onClick: closeImage, children: _jsxs("div", { className: "relative max-w-[90vw] max-h-[90vh]", children: [_jsx("img", { src: image.src, alt: image.alt || t('agent.enlargedView'), className: "max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl" }), _jsx("button", { className: "absolute top-2 right-2 text-white bg-black/50 rounded-full p-2 hover:bg-black/70 transition-colors", onClick: closeImage, title: t('agent.close'), children: _jsx(X, { className: "size-6" }) }), _jsx("a", { href: image.src, target: "_blank", rel: "noopener noreferrer", className: "absolute bottom-2 right-2 text-white bg-black/50 rounded-full p-2 hover:bg-black/70 transition-colors", onClick: (e) => e.stopPropagation(), title: t('agent.openInNewTab'), children: _jsx(ExternalLink, { className: "size-5" }) })] }) }))] }));
}
export function LightboxImage({ src, alt, className }) {
    const { openImage } = useImageLightbox();
    return (_jsx("img", { src: src, alt: alt, className: `cursor-pointer hover:opacity-90 transition-opacity ${className || ""}`, onClick: (e) => {
            e.stopPropagation();
            openImage(src, alt);
        } }));
}
//# sourceMappingURL=ImageLightbox.js.map